/**
 * Used for the certificate creation wizard.
 * @type {{PQC: string, TRADITIONAL: string}}
 */
const values = {
  TRADITIONAL: "traditional",
  PQC: "pqc"
};

export default Object.freeze(values);
